import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  IonModal,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonButton,
  IonContent,
} from '@ionic/vue';
import { ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BasicModal',
  props: {
  modelValue: {
    type: Boolean,
    required: true,
  },
},
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const props = __props;





const proxyIsOpen = ref(props.modelValue);

watch(
    () => props.modelValue,
    (value) => {
      proxyIsOpen.value = value;
    }
);

function handleModalClose() {
    proxyIsOpen.value = false;
    emit('update:modelValue', false);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonModal), {
    "is-open": proxyIsOpen.value,
    onIonModalDidDismiss: handleModalClose
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "title", {}, () => [
                    _createTextVNode(" Modal ")
                  ])
                ]),
                _: 3
              }),
              _createVNode(_unref(IonButtons), { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonButton), { onClick: handleModalClose }, {
                    default: _withCtx(() => [
                      _createTextVNode("Close")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 3
          })
        ]),
        _: 3
      }),
      _createVNode(_unref(IonContent), { class: "content__outer" }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["is-open"]))
}
}

})